var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalxeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6604 15.1285L10.1305 25.2877L26.417 13.223C26.9628 12.8189 27.7374 12.9812 28.0759 13.5706C28.3894 14.1164 28.2034 14.8138 27.6597 15.1293L27.6604 15.1285ZM30.1652 23.9215C29.9301 23.5124 29.4092 23.3729 29.0015 23.609L17.3962 30.3341L29.7562 25.1375C30.2294 24.9387 30.421 24.3679 30.1645 23.9215H30.1652ZM36.0206 14.9061C35.5297 14.0527 34.4244 13.7888 33.6035 14.3288L8.25 31L35.3102 17.2959C36.1867 16.8517 36.5116 15.7594 36.0206 14.9061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalxeIcon);
export default __webpack_public_path__ + "static/media/galxeIcon.69c0baadb2f5059c64a23c203f6e3f58.svg";
export { ForwardRef as ReactComponent };